import React from 'react'
import './css.css'

export default function Burger(props) {

    return (
        <div className={props.classButtons === '' ? 'burger' : 'burger toggle'} onClick={props.onClickBurger}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
        </div>
    )
}
